import './App.css';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom"
import { ContactUs, Dashboard, Profile, Product } from "./pages"

function App() {
  return (
    <Router>
      <Switch>
        <Route exact path="/">
          <Dashboard/>
        </Route>
        <Route exact path="/profil">
          <Profile/>
        </Route>
        <Route exact path="/produk">
          <Product/>
        </Route>
        <Route exact path="/hubungi-kami">
          <ContactUs/>
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
